import { BudgetStatusEnum } from "../../../../enums/budgetStatus";
import { BudgetRecipientEnum } from "../types";

interface IBudgetInfoBarProps {
  occurrenceProtocolNumber?: string;
  occurrenceContractNumber?: string;
  budgetNumber?: string;
  profile?: BudgetRecipientEnum;
  status?: BudgetStatusEnum;
  onViewAttachments?: () => void;
  onUploadFiles?: () => void;
  budgetId: string;
}

const BudgetInfoBar = (props: IBudgetInfoBarProps) => {
  return (
    <div className="flex items-center justify-between mb-4 px-6 py-4 bg-white border-b border-t border-gray-200 mt-5 ">
      <div className="flex items-center gap-4">
        <span className="font-bold">{props.occurrenceContractNumber ? `Contrato ${props.occurrenceContractNumber}` : ''}</span>
        
        <span className="font-bold mx-2 text-gray-400">{props.occurrenceContractNumber && props.occurrenceProtocolNumber ? '—' : ''}</span>
        <span className="font-bold">{props.occurrenceProtocolNumber ? `Ocorrência ${props.occurrenceProtocolNumber}` : ''}</span>

        <span className="font-bold mx-2 text-gray-400">{props.occurrenceContractNumber && props.occurrenceProtocolNumber && props.budgetNumber ? '—' : ''}</span>
        <span className="font-bold">{props.budgetNumber ? `Orçamento ${props.budgetNumber}` : ''}</span>

        {props.onViewAttachments && <span className="flex gap-2 flex-row">
          <button
            className="text-gray-800 underline underline-offset-2 flex items-center gap-1 hover:opacity-80 text-size-14 whitespace-nowrap cursor-pointer"
            onClick={props.onViewAttachments}
          >
            <img
              src="/assets/images/docs.svg"
              alt="Documento"
              className="w-6 h-6 flex-shrink-0"
            />
            <span>Visualizar orçamento</span>
          </button>
        </span>}
      </div>
      <button
        className="text-gray-800 underline underline-offset-2 flex items-center gap-1 hover:opacity-80 text-size-14 whitespace-nowrap cursor-pointer"
        onClick={props.onUploadFiles}
      >
        <img
          src="/assets/images/uploadFiles.svg"
          alt="Documento"
          className="w-11 h-10 flex-shrink-0"
        />
      </button>
    </div>
  );
};

export default BudgetInfoBar;
